/**
 * Created by asiulik on 20.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../store/favouriteStore'], function($, _, EventEmitter, FavouriteStore){


    var config = {
        calculatorOverlaySelector: "#terminOverlay",
        sliderTriggerSelector: "[data-termin-overlay-trigger]"
    };

    function OverlayTermin(overlayInstance){
        this.overlay = overlayInstance;
    }

    OverlayTermin.prototype = _.clone(EventEmitter.prototype);

    OverlayTermin.prototype.init = function(){

        this.favourtiesStore = new FavouriteStore();

        this.$triggerElements = $(config.sliderTriggerSelector);
        this.$calculatorOverlay = $(config.calculatorOverlaySelector);

        this.bindEvents();

    };

    OverlayTermin.prototype.bindEvents = function(){

        var _this = this;

        this.$triggerElements.on({
            click: function(e){
                e.preventDefault();

                var $this = $(this);

                _this.openTerminOverlay($this);
                _this.fillHiddenField();

            }
        })

    };

    OverlayTermin.prototype.openTerminOverlay = function($triggerElement){

        this.overlay.openOverlay(
            this.$calculatorOverlay
        );

    };

    OverlayTermin.prototype.fillHiddenField = function() {
        var favourites = this.favourtiesStore.getFavourites();
        $('#terminOverlay').find("input[id$='favourite-id']").val(favourites.general.code);
        $('#terminOverlay').find("input[id$='favourite-value']").val(JSON.stringify(favourites));

    }


    return OverlayTermin

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlayTermin.js